import {useBreakpoint, useIsMobile} from "@brg/ui";
import { ProjectsButchController } from "core/controllers/ProjectsButchController";
import {FC, useCallback, useEffect, useMemo, useState} from "react";
import { SelectChaptersModalWrapper } from "./styles";
import {SendProjectsEntity} from "../sendProjects/SendProjectsEntity";
import {SendProjectModalWrapper} from "../sendProjects/employStyles";
import {SortingTypeIndex} from "../../constants/sortingType";
import {useModal} from "../../../core";


export interface SelectChaptersProps {
    onSelect?: (projectId: string, isFirst?: boolean, isMultiple?: boolean) => void;
    onUnSelect?: (projectId: string) => void;
    projectIds?: string[];
    authorsIds?: string[];
    bookStatus?: number,
    bookId?: string
}

export const SelectChapters: FC<SelectChaptersProps> = (props) => {
    const { onSelect, onUnSelect, projectIds = [], authorsIds, bookStatus, bookId } = props;
    const [selectedProjectIds, setSelectedProjectIds] = useState<string[]>([]);
    const [time, setT] = useState(new Date().getTime());
    const [sorting, setSorting] = useState(1);
    const modal = useModal();

    const isTab = useBreakpoint(1200)

    const isMobile = useIsMobile();

    useEffect(() => {
        setSelectedProjectIds(projectIds ?? []);
    }, [projectIds]);


    const projectsFilter = useMemo(() => ({
        projectFilter: 9,
        isLite: true,
        limit: 40,
        projectStatus: [0, 1],
        bookId: bookId,
        isContextIgnored: true,
        authorOrCoAuthorIds: authorsIds,
        selectChapters: true,
        contextsNotContains: ['lmsproject', 'lmshseproject']
    }), [authorsIds, bookId]);

    const onMobileSortingClick = useCallback(() => {
        setSorting(sorting === 1 ? 2 : 1);
    }, [sorting, setSorting]);

    const onSortingChange = useCallback((s: SortingTypeIndex): void => {
        setSorting(s);
        setT(Date.now());
    }, []);

    const onSendProjects = useCallback(() => {

        let isFirst = true;
        selectedProjectIds && selectedProjectIds.forEach((projectId, index) => {

            if (!projectIds.includes(projectId)) {
                onSelect?.(projectId, isFirst, selectedProjectIds?.length > 1);
                isFirst = false;
            }
        })
        projectIds && projectIds.forEach(projectId => {
            if (!selectedProjectIds.includes(projectId)) {
                onUnSelect?.(projectId);
            }
        })
        modal.hide();
    }, [selectedProjectIds, projectIds]);
        
    return (
        <SelectChaptersModalWrapper scroll={true}>
            <SendProjectModalWrapper offsetTop={isMobile ? 0 : 170} width={'100%'} directionMobile='column' direction='column' justify={'flex-start'} align={"center"} style={{ position: 'relative'}}>
                <SendProjectsEntity hideFilter count={selectedProjectIds?.length || 0} onMobileSortingClick={onMobileSortingClick} onSortingChange={onSortingChange} sorting={sorting} onSend={onSendProjects}>
                    <ProjectsButchController
                        metaAlwaysVisible={isTab}
                        filter={projectsFilter}
                        selectable={true}
                        selectedProjects={selectedProjectIds}
                        onSelect={projectId => {
                            setSelectedProjectIds((prev: string[]) => {
                                if (prev.includes(projectId)) return prev.filter(a => a !== projectId);
                                return [...prev, projectId];
                            });
                        }}
                        date={time}
                        isInfinityNeed={false}
                        modal={true}
                        // isSelectRightNeed={isMobile}
                        noPresentation
                    />
                </SendProjectsEntity>
            </SendProjectModalWrapper>
        </SelectChaptersModalWrapper>
    );
};
import {useBreakpoint, useIsMobile} from "@brg/ui";
import { ProjectsButchController } from "core/controllers/ProjectsButchController";
import {FC, useCallback, useEffect, useMemo, useState} from "react";
import { SelectChaptersModalWrapper } from "./styles";
import {SendProjectsEntity} from "../sendProjects/SendProjectsEntity";
import {SendProjectModalWrapper} from "../sendProjects/employStyles";
import {SortingTypeIndex} from "../../constants/sortingType";
import {useModal} from "../../../core";


export interface SelectChaptersProps {
    onSelect?: (projectId: string, isFirst?: boolean, isMultiple?: boolean) => void;
    onUnSelect?: (projectId: string) => void;
    projectIds?: string[];
    authorsIds?: string[];
    bookStatus?: number,
    bookId?: string
}

export const SelectChapters: FC<SelectChaptersProps> = (props) => {
    const { onSelect, onUnSelect, projectIds = [], authorsIds, bookStatus, bookId } = props;
    const [selectedProjectIds, setSelectedProjectIds] = useState<string[]>([]);
    const [time, setT] = useState(new Date().getTime());
    const [sorting, setSorting] = useState(1);
    const modal = useModal();

    const isTab = useBreakpoint(1200)

    const isMobile = useIsMobile();

    useEffect(() => {
        setSelectedProjectIds(projectIds ?? []);
    }, [projectIds]);


    const projectsFilter = useMemo(() => ({
        projectFilter: 9,
        isLite: true,
        limit: 40,
        projectStatus: [0, 1],
        bookId: bookId,
        isContextIgnored: true,
        authorOrCoAuthorIds: authorsIds,
        selectChapters: true,
        contextsNotContains: ['lmsproject', 'lmshseproject']
    }), [authorsIds, bookId]);

    const onMobileSortingClick = useCallback(() => {
        setSorting(sorting === 1 ? 2 : 1);
    }, [sorting, setSorting]);

    const onSortingChange = useCallback((s: SortingTypeIndex): void => {
        setSorting(s);
        setT(Date.now());
    }, []);

    const onSendProjects = useCallback(() => {

        let isFirst = true;
        selectedProjectIds && selectedProjectIds.forEach((projectId, index) => {

            if (!projectIds.includes(projectId)) {
                onSelect?.(projectId, isFirst, selectedProjectIds?.length > 1);
                isFirst = false;
            }
        })
        projectIds && projectIds.forEach(projectId => {
            if (!selectedProjectIds.includes(projectId)) {
                onUnSelect?.(projectId);
            }
        })
        modal.hide();
    }, [selectedProjectIds, projectIds]);
        
    return (
        <SelectChaptersModalWrapper scroll={true}>
            <SendProjectModalWrapper offsetTop={isMobile ? 0 : 170} width={'100%'} directionMobile='column' direction='column' justify={'flex-start'} align={"center"} style={{ position: 'relative'}}>
                <SendProjectsEntity hideFilter count={selectedProjectIds?.length || 0} onMobileSortingClick={onMobileSortingClick} onSortingChange={onSortingChange} sorting={sorting} onSend={onSendProjects}>
                    <ProjectsButchController
                        metaAlwaysVisible={isTab}
                        filter={projectsFilter}
                        selectable={true}
                        selectedProjects={selectedProjectIds}
                        onSelect={projectId => {
                            setSelectedProjectIds((prev: string[]) => {
                                if (prev.includes(projectId)) return prev.filter(a => a !== projectId);
                                return [...prev, projectId];
                            });
                        }}
                        date={time}
                        isInfinityNeed={false}
                        modal={true}
                        // isSelectRightNeed={isMobile}
                        noPresentation
                    />
                </SendProjectsEntity>
            </SendProjectModalWrapper>
        </SelectChaptersModalWrapper>
    );
};
